import { Stack, SvgIcon, Tab, Tabs, useTheme } from '@mui/material';

import { ChevronLeftSvgIcon } from '@zeta-core/assets';
import { BreadcrumbsLinkProps, CustomBreadcrumbs, useTabs } from '@zeta-core';
import { DASHBOARD_CONFIG } from '../common/constants';
import { RouterLinks } from '../../app-route-paths';
import InfoCard from './info-card';

const ReportSidebar = () => {
  const theme = useTheme();
  const LINKS: BreadcrumbsLinkProps[] = [
    {
      name: 'Alex Cupa',
      href: RouterLinks.myTasks,
      icon: (
        <SvgIcon>
          <ChevronLeftSvgIcon />
        </SvgIcon>
      ),
    },
    { name: 'Protection', href: RouterLinks.report },
  ];

  const TABS = {
    CLIENT_DETAILS: { label: 'Client Details', value: 'C' },
    PARTNER_DETAILS: { label: 'Partner Details', value: '' },
  };

  const MOCK_DATA = [
    {
      title: 'Client Details',
      info: [
        { label: 'Client Name', value: 'Alex Cupa' },
        { label: 'Contact Number', value: '+44 123 456 7890' },
        { label: 'Email', value: 'alex@gmail.com' },
        { label: 'Address', value: '123 Main Street, London, UK' },
      ],
    },
    {
      title: 'Health Information',
      info: [
        { label: 'Smoker', value: 'No' },
        { label: 'Medical Condition', value: 'None reported' },
      ],
    },
    {
      title: 'GP Information',
      info: [
        { label: 'Company GP Name', value: 'Dr. Sarah Smith' },
        { label: 'GP Practice Name', value: 'Central London Medical' },
        { label: 'GP Contact', value: '+44 987 654 3210' },
        { label: 'GP Address', value: '456 Health Avenue, London, UK' },
      ],
    },
  ];

  const tab = useTabs(TABS.CLIENT_DETAILS.value);

  return (
    <Stack
      sx={{
        position: 'fixed',
        left: 0,
        top: DASHBOARD_CONFIG.HEADER.DESKTOP_HEIGHT,
        height: `calc(100vh - ${DASHBOARD_CONFIG.HEADER.DESKTOP_HEIGHT}px)`,
        width: DASHBOARD_CONFIG.NAVIGATION.DESKTOP_WIDTH,
        p: 3,
        gap: 3,
        bgcolor: theme.palette.grey[100],
        overflowY: 'auto',
        scrollbarGutter: 'stable',
        scrollbarWidth: 'thin',
      }}
    >
      <CustomBreadcrumbs links={LINKS} sx={{ pb: 1 }} />

      <Tabs {...tab}>
        <Tab {...TABS.CLIENT_DETAILS} />
        <Tab {...TABS.PARTNER_DETAILS} />
      </Tabs>
      {MOCK_DATA.map((item) => (
        <InfoCard {...item} key={item.title} />
      ))}
    </Stack>
  );
};

export default ReportSidebar;
